import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Box, SxProps, Theme, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { FC } from 'react';

import { Iconify } from '@components/Iconify';

export type ValidationMode = 'camera' | 'scanner';

const CAMERA_DISABLED_TOOLTIP = 'Label printing is required for camera mode';

type ValidationModeToggleProps = {
  mode: ValidationMode;
  onModeChange: (mode: ValidationMode) => void;
  cameraDisabled: boolean;
  hideLabels: boolean;
  sx?: SxProps<Theme>;
};

export const ValidationModeToggle: FC<ValidationModeToggleProps> = ({
  mode,
  onModeChange,
  cameraDisabled,
  hideLabels,
  sx,
}) => {
  const cameraTooltip = cameraDisabled ? CAMERA_DISABLED_TOOLTIP : hideLabels ? 'Camera' : '';
  const scannerTooltip = hideLabels ? 'Scanner' : '';

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode}
      onChange={(_, newMode: ValidationMode | null) => {
        if (newMode) onModeChange(newMode);
      }}
      aria-label="Validation mode"
      sx={sx}
    >
      <Tooltip arrow title={cameraTooltip}>
        <Box component="span" sx={{ display: 'flex', borderRadius: 'inherit' }}>
          <ToggleButton value="camera" disabled={false} aria-label="Camera">
            <PhotoCameraIcon sx={hideLabels ? undefined : { mr: 1 }} />
            {!hideLabels && 'Camera'}
          </ToggleButton>
        </Box>
      </Tooltip>
      <Tooltip arrow title={scannerTooltip}>
        <Box component="span" sx={{ display: 'flex', borderRadius: 'inherit' }}>
          <ToggleButton value="scanner" aria-label="Scanner">
            <Iconify icon="material-symbols:barcode-reader" width={24} sx={hideLabels ? undefined : { mr: 1 }} />
            {!hideLabels && 'Scanner'}
          </ToggleButton>
        </Box>
      </Tooltip>
    </ToggleButtonGroup>
  );
};
